var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-layout"},[_c('div',{staticClass:"b-container"},[_c('BNavbar'),_c('router-view',{staticClass:"router-view"}),_c('BTabbar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }